<template>
<div class="idea" :style="{paddingTop: headerHeight + 'px'}"  v-loading="pageLoading">
<SubHeader :showUser="true"></SubHeader>
<div class="box-line" id="line"></div>
 
  <div class="right">
    <div class="type">
      <div class="type-btn" @click="getTag(1)" :class="{ active: tag == 1 }">最热锦囊</div>
      <div class="type-btn" @click="getTag(2)" :class="{ active: tag == 2 }">最新锦囊</div>
    </div>
    <div class="type-select_line"></div>
    <div class="type">
      <div class="type-btn" @click="changeType(item.id)" :class="{ active:typeIndex == item.id}" v-for="item of typeList" :key="item.id">{{item.name}}</div>
    </div>
    <div class="type-select_line"></div>
    <idea-list :list="list"></idea-list>
  </div>
</div>
</template>

<script>
import SubHeader from "@/components/SubHeader";
import ideaList from "@/components/ideaList";
export default {
  name: "Home",
  data() {
    return {
      typeList:[{
        name:'全部分类',
        id:0
      }],
      typeIndex:0,
      pageLoading: false,
      list: [],
      allList:[],
      tag: 1,
      page:1,
      limit:1000,
    
    }
  },
  components:{SubHeader,ideaList},
  mounted() {
    window.addEventListener('scroll', this.onLoad);
    this.getType();
  },
  destroyed() {
    window.removeEventListener('scroll', this.onLoad)
  },
  computed: {
    plat() {
      return this.$store.state.plat_id
    },
    headerHeight() {
      return this.$store.state.headerHeight;
    }
  },
  methods: {
    // 获取锦囊分类
    async getType(){
      let res = await this.$api({
          method: "get",
          url: "/api/silkbag/category/list",
          data: {
            goods_category_id: this.plat,
            page: 1,
            limit: 1000
          }
        });
        if(res.code == 0){
          this.typeList = [{
          name:'全部分类',
          id:0
      }]
        this.typeList.push(...res.data.category)
        res.data.total_silk.forEach(item=>{
          item.updated_at = item.updated_at.slice(0,10)
          item.content = item.content.replace(/<\/?[^>]*>/g, "")
          item.content = item.content.length>100 ? item.content.slice(0,100)+'...' : item.content
        })
        this.allList = res.data.total_silk
        this.list = this.allList
        // this.getList()
      }else{
        this.$toast(res.msg)
      }
    },
    changeType(id){
      this.typeIndex = id
      if(this.typeIndex){
        this.getList()
      }else{
        this.getType()
      }
    },
    getTag(index) {
      this.tag = index;
      if(this.typeIndex){
        this.getList()
      }else{
        this.getType()
      }
    },
    async getList() {
      this.pageLoading = true;
      document.documentElement.scrollTop = 0;
      // 锦囊列表
      let res = await this.$api({
        method: 'get',
        url: "/api/silkbag/list",
        data:{
          category_id: this.typeIndex === 0 ? '' : this.typeIndex,
          page: this.page,
          limit : this.limit,
          sort:this.tag,
        }
      });
      
      if (res.code == 0) {
    
        res.data.forEach(item=>{
          item.updated_at = item.updated_at.slice(0,10)
          item.content = item.content.replace(/<\/?[^>]*>/g, "")
          item.content = item.content.length>100 ? item.content.slice(0,100)+'...' : item.content
        })
        this.list = res.data
      } else {
        this.$toast(res.msg)
      }
      this.pageLoading = false;
    },
   
  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate')
    // console.log(to)
    next()
  },

};
</script>

<style lang="scss" scoped>
.idea {
  min-height: calc(100vh - 230px);
  display: flex;
  align-items: flex-start;
  overflow: hidden;

  .van-sticky {
    left: auto;
    right: auto;
  }

  .left {
    margin-right: 40px;
    width: 300px;
    overflow: hidden;
    margin-top: 30px;
  }

  .classify {
    background: #fff;
    box-shadow: 0 5px 10px #33333308;
    border-radius: 12px;
    flex: 0 0 300px;
    display: flex;
    flex-wrap: wrap;
    padding: 20px 10px;

    .classify-item {
      width: 50%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333;
      font-size: 22px;
      margin-bottom: 20px;
      cursor: pointer;

      &:hover {
        color: #a40001;
      }
    }

    .active {
      color: #a40001;
      font-weight: 600;
    }
  }

  .hot-title {
    font-size: 22px;
    font-weight: 500;
    border-bottom: 1px solid #eee;
    padding: 0 20px 15px;
    width: 100%;
    display: block;
    margin-bottom: 10px;
  }

  .hot-item {
    width: 100%;
    display: flex;
    display: flex;
    align-items: center;
    border-radius: 10px;
    padding: 10px;
    cursor: pointer;

    &:hover {
      background: #f8f8f8;
    }

    .cover {
      flex: 0 0 84px;
      height: 84px;
      margin-right: 10px;
    }

    .detail {
      flex: auto;

      .title {
        font-size: 16px;
        font-weight: 500;
      }

      .subtitle {
        font-size: 12px;
        color: #666;
      }
    }
  }

  .right {
    flex: 1;
    // margin-top: 30px;
    padding: 0 10px;
    box-sizing: border-box;
    .type-select_line {
      border-bottom: 1px solid #E4E5E6;
      width: 100%;
      margin: 0 auto;
    }
  }

  .idea-list {
    background: #fff;
    box-shadow: 0 5px 10px #33333308;
    border-radius: 12px;
    padding: 20px 20px;
    margin-bottom: 20px;
    cursor: pointer;

    .title {
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 10px;
    }

    .content {
      display: flex;
      width: 100%;

      .cover {
        flex: 0 0 280px;
        margin-right: 20px;
        width: 280px;
        height: 136px;
        border-radius: 10px;
        overflow: hidden;
      }

      .detail {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        flex: auto;

        .text {
          font-size: 14px;
          color: #666;
          overflow: hidden;
          display: -webkit-box;
          /*弹性伸缩盒子*/
          -webkit-box-orient: vertical;
          /*子元素垂直排列*/
          -webkit-line-clamp: 5;
          /*可以显示的行数，超出部分用...表示*/
          text-overflow: ellipsis;
          /*（多行文本的情况下，用省略号“…”隐藏溢出范围的文本)*/
        }

        .more {
          font-size: 14px;
          color: #175199;
          display: flex;
          align-items: center;
          margin-top: 10px;
          cursor: pointer;
        }

      }

      .handle {
        margin-left: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 120px;
      }

      .btn {
        cursor: pointer;
        border-radius: 6px;
        line-height: 40px;
        font-weight: 500;
        border-radius: 6px;
        color: #a40001;
        background: #f7f7f7;
        padding: 0 30px;
        font-size: 14px;

        &:hover {
          color: #fff;
          background: #a40001;
        }
      }
    }
  }

  .type {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 60px;
    margin: 20px 0;

    .type-btn {
      width: 140px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #a40001;
      background: #eee;
      border-radius: 4px;
      cursor: pointer;
      margin-right: 20px;
      transition: all 0.3s;

      &:hover {
        color: #fff;
        background: #a40001;
      }
    }

    .active {
      color: #fff;
      background: #a40001;
    }
  }

  .article {
    width: 960px;
    background: #fff;
    min-height: 100vh;
    margin: 20px auto;
    padding: 30px;

    .art-title {
      font-size: 32px;
      margin-bottom: 20px;
    }

    .art-user {
      display: flex;
      align-items: center;
    }

    .user-msg {
      font-size: 20px;
      color: #333;
      margin-left: 10px;
    }
  }

  .idea,
  .cert {

    .idea-nav,
    .idea-list,
    .cert-list {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    .idea-nav-item {
      width: calc((100% - 200px) / 7);
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #a40001;
      background: #eee;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        color: #fff;
        background: #a40001;
      }
    }

    .idea-card {
      margin-top: 40px;
      width: calc((100% - 60px) / 3);
      // height: 300px;
      background: #fff;
      border-radius: 8px;
      cursor: pointer;
      padding: 20px;

      .card-title {
        font-weight: 500;
        margin-bottom: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        font-size: 26px;
      }

      .card-subtitle {
        overflow: hidden;
        font-size: 18px;
        color: #666;
        overflow: hidden;
        display: -webkit-box;
        /*弹性伸缩盒子*/
        -webkit-box-orient: vertical;
        /*子元素垂直排列*/
        -webkit-line-clamp: 5;
        /*可以显示的行数，超出部分用...表示*/
        text-overflow: ellipsis;
        /*（多行文本的情况下，用省略号“…”隐藏溢出范围的文本)*/
      }
    }

    .cert-card {
      width: calc((100% - 60px) / 3);
      background: #fff;
      border-radius: 8px;
      cursor: pointer;
      overflow: hidden;
      margin-bottom: 30px;
      margin-right: 20px;

      .card-detail {
        background: #fff;
        padding: 16px 16px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .card-cover {
        width: 100%;
        border-radius: 8px 8px 0 0;
        box-sizing: border-box;
      }

      .card-title {
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        font-size: 26px;
      }

      .card-btn {
        cursor: pointer;
        border-radius: 6px;
        line-height: 32px;
        font-weight: 500;
        border-radius: 6px;
        color: #a40001;
        background: #f7f7f7;
        padding: 0 20px;
        font-size: 16px;
        flex: 0 0 auto;

        &:hover {
          color: #fff;
          background: #a40001;
        }
      }
    }
  }
}


</style>

<style lang="scss">

</style>
